export const getDeviceType = () => {
  if (typeof window !== 'undefined') {
    return window.navigator.userAgent.indexOf('Mobi') !== -1
      ? 'mobile'
      : 'desktop';
  } else {
    return undefined;
  }
};
